// @flow
import * as colors from './colors'

const header = {
    header: {
        backgroundColor: colors.primaryOne,
        boxShadow: '1px 0 2px 1px rgba(0, 0, 0, 0.44)',
        zIndex: 403,
        '-webkitTransform': 'translate3d(0,0,100px)',
        color: colors.white,
        gridColumnStart: 'left',
        gridColumnEnd: 'right',
        gridRowStart: 'top',
        gridRowEnd: 'subHeader',
        paddingRight: '15px',
        paddingLeft: '15px',
    },
    headerCtr: {
        paddingRight: '15px',
        paddingLeft: '15px',
    },
    headerLink: {
        color: colors.white,
        textDecoration: 'none',
    },
    headerSection: {
        color: colors.textColor,
        fontWeight: 'bold',
        marginBottom: '0px',
        marginTop: '10px',
        paddingLeft: '15px',
    },
}
export default header
